
import './pip.css';

const Pip = props => {
    return (
        <div className="pip"><a href={props.handle} ><img src={props.imageSource} className="pip-icon" alt={props.handle} /></a></div>
    )
}

export default Pip